import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/progress/index.js
// module id = null
// module chunks = 